(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alpe-kit-builder"] && !Shopify.designMode) return;
  try {
    
  class AlpeKitBuilder extends HTMLElement {
    connectedCallback() {
      this.currency = this.dataset.currency || 'EUR';
      this.root = this.dataset.root || '/';
      this.kitName = this.dataset.kitName || 'Poletni komplet';
      this.discountPercent = Number(this.dataset.discountPercent || 0);
      this.discountCode = (this.dataset.discountCode || '').trim();
      this.afterAdd = this.dataset.afterAdd || 'cart';
      this.entries = this.readEntries();
      this.products = [];
      this.requiredLanes = ['jersey', 'bib', 'accessory'];
      this.selection = {};
      this.loading = false;
      this.cacheNodes();
      this.setStatus('Nalagam izdelke.');
      this.loadProducts();
      this.bindStepNav();
      this.bindSubmit();
      this.render();
    }

    cacheNodes() {
      this.summaryList = this.querySelector('[data-kit-summary-list]');
      this.status = this.querySelector('[data-kit-status]');
      this.hint = this.querySelector('[data-kit-hint]');
      this.submitButtons = Array.from(this.querySelectorAll('[data-kit-submit]'));
    }

    readEntries() {
      const node = this.querySelector('[data-kit-products]');
      if (!node) return [];
      try {
        return JSON.parse(node.textContent)
          .filter(Boolean)
          .filter((entry) => entry.handle && entry.lane);
      } catch (error) {
        this.setStatus('Konfiguracije kompleta ni bilo mogoče naložiti.');
        return [];
      }
    }

    async loadProducts() {
      const loaded = await Promise.all(this.entries.map(async (entry) => {
        try {
          const response = await fetch(`${this.root}products/${entry.handle}.js`, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) return null;
          const product = await response.json();
          const variants = (product.variants || []).filter((variant) => variant.available);
          if (!variants.length) return null;
          return {
            ...entry,
            productUrl: `${this.root}products/${entry.handle}`,
            image: product.featured_image || (product.images && product.images[0]) || null,
            product,
            variants
          };
        } catch (error) {
          return null;
        }
      }));
      this.products = loaded.filter(Boolean);
      this.renderHeroImages();
      this.renderProducts();
      this.render();
      if (!this.products.length) {
        this.setStatus('Izdelki kompleta niso dosegljivi.');
      } else {
        this.setStatus('');
      }
    }

    bindStepNav() {
      this.querySelectorAll('[data-kit-step-target]').forEach((button) => {
        button.addEventListener('click', () => {
          const lane = this.querySelector(`[data-kit-lane="${button.dataset.kitStepTarget}"]`);
          if (lane) lane.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    bindSubmit() {
      this.submitButtons.forEach((button) => {
        button.dataset.originalText = button.textContent;
        button.addEventListener('click', () => this.addToCart());
      });
    }

    renderProducts() {
      this.requiredLanes.forEach((lane) => {
        const grid = this.querySelector(`[data-kit-grid="${lane}"]`);
        if (!grid) return;
        grid.innerHTML = '';
        this.products.filter((entry) => entry.lane === lane).forEach((entry) => {
          grid.appendChild(this.createProductCard(entry));
        });
      });
    }

    renderHeroImages() {
      const lanes = ['jersey', 'bib', 'accessory'];
      lanes.forEach((lane, index) => {
        const tile = this.querySelector(`.alpe-kit__hero-tile--${index + 1}`);
        const entry = this.products.find((item) => item.lane === lane && item.image);
        if (!tile || !entry) return;
        tile.innerHTML = '';
        const image = document.createElement('img');
        image.src = entry.image;
        image.alt = entry.product.title;
        image.className = 'alpe-kit__hero-image';
        image.loading = 'eager';
        tile.appendChild(image);
      });
    }

    createProductCard(entry) {
      const card = document.createElement('article');
      card.className = 'alpe-kit__card';
      card.dataset.productKey = entry.blockId;

      const media = document.createElement('div');
      media.className = 'alpe-kit__media';
      if (entry.image) {
        const image = document.createElement('img');
        image.src = entry.image;
        image.alt = entry.product.title;
        image.loading = 'lazy';
        media.appendChild(image);
      } else {
        const fallback = document.createElement('div');
        fallback.className = 'alpe-kit__image-fallback';
        fallback.textContent = entry.role || this.laneLabel(entry.lane);
        media.appendChild(fallback);
      }

      const body = document.createElement('div');
      body.className = 'alpe-kit__body';

      const top = document.createElement('div');
      top.className = 'alpe-kit__card-top';
      const titleWrap = document.createElement('div');
      const role = document.createElement('p');
      role.className = 'alpe-kit__eyebrow';
      role.textContent = entry.role || this.laneLabel(entry.lane);
      const title = document.createElement('h3');
      title.className = 'alpe-kit__product-title';
      title.textContent = entry.product.title;
      titleWrap.append(role, title);
      const price = document.createElement('div');
      price.className = 'alpe-kit__price';
      price.textContent = this.formatMoney(entry.variants[0]?.price || entry.product.price);
      top.append(titleWrap, price);

      const note = document.createElement('p');
      note.className = 'alpe-kit__note';
      note.textContent = entry.note || '';

      const variantLabel = document.createElement('p');
      variantLabel.className = 'alpe-kit__variant-label';
      variantLabel.textContent = this.variantLabel(entry);

      const variants = document.createElement('div');
      variants.className = 'alpe-kit__variants';
      entry.variants.forEach((variant) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'alpe-kit__variant';
        button.textContent = this.cleanVariantTitle(variant.title);
        button.addEventListener('click', () => {
          this.selection[entry.lane] = { entry, variant };
          this.render();
        });
        variants.appendChild(button);
      });

      const select = document.createElement('button');
      select.type = 'button';
      select.className = 'alpe-kit__select';
      select.textContent = 'Izberi kos';
      select.addEventListener('click', () => {
        const firstVariant = entry.variants[0];
        this.selection[entry.lane] = { entry, variant: firstVariant };
        this.render();
      });

      body.append(top);
      if (note.textContent) body.append(note);
      body.append(variantLabel, variants, select);
      card.append(media, body);
      return card;
    }

    render() {
      this.renderCards();
      this.renderSummary();
      this.renderSteps();
    }

    renderCards() {
      this.products.forEach((entry) => {
        const card = this.querySelector(`[data-product-key="${entry.blockId}"]`);
        if (!card) return;
        const selected = this.selection[entry.lane];
        const isSelectedProduct = selected?.entry.blockId === entry.blockId;
        card.classList.toggle('is-selected', Boolean(isSelectedProduct));
        card.querySelectorAll('.alpe-kit__variant').forEach((button, index) => {
          const variant = entry.variants[index];
          button.classList.toggle('is-selected', Boolean(isSelectedProduct && selected.variant.id === variant.id));
        });
        const select = card.querySelector('.alpe-kit__select');
        if (select) {
          select.classList.toggle('is-selected', Boolean(isSelectedProduct));
          select.textContent = isSelectedProduct ? 'Izbrano' : 'Izberi kos';
        }
      });
    }

    renderSummary() {
      const selected = this.getSelected();
      const subtotal = selected.reduce((sum, item) => sum + Number(item.variant.price || 0), 0);
      const complete = this.isComplete();
      const discount = complete && this.discountCode && this.discountPercent > 0
        ? Math.round(subtotal * this.discountPercent / 100)
        : 0;
      const total = Math.max(subtotal - discount, 0);

      if (this.summaryList) {
        this.summaryList.innerHTML = '';
        if (!selected.length) {
          const empty = document.createElement('p');
          empty.className = 'alpe-kit__summary-empty';
          empty.textContent = 'Izberi dres, hlače in dodatek.';
          this.summaryList.appendChild(empty);
        } else {
          selected.forEach(({ entry, variant }) => {
            const row = document.createElement('div');
            row.className = 'alpe-kit__summary-item';
            const title = document.createElement('div');
            title.innerHTML = `${this.escapeHtml(this.laneLabel(entry.lane))}<span>${this.escapeHtml(entry.product.title)} · ${this.escapeHtml(this.cleanVariantTitle(variant.title))}</span>`;
            const price = document.createElement('strong');
            price.textContent = this.formatMoney(variant.price);
            row.append(title, price);
            this.summaryList.appendChild(row);
          });
        }
      }

      this.setText('[data-kit-subtotal]', this.formatMoney(subtotal));
      this.setText('[data-kit-discount]', `-${this.formatMoney(discount)}`);
      this.setText('[data-kit-total]', this.formatMoney(total));
      this.setText('[data-kit-mobile-total]', this.formatMoney(total));
      this.setText('[data-kit-mobile-count]', this.formatCount(selected.length));

      const discountRow = this.querySelector('[data-kit-discount-row]');
      if (discountRow) discountRow.hidden = discount <= 0;

      const missing = this.getMissingLanes();
      if (this.hint) {
        this.hint.classList.toggle('is-good', complete);
        if (!complete) {
          this.hint.textContent = `Manjka še: ${missing.map((lane) => this.laneLabel(lane).toLowerCase()).join(', ')}.`;
        } else if (this.discountCode && this.discountPercent > 0) {
          this.hint.textContent = `${this.discountPercent} % popust se aktivira pri dodajanju kompleta.`;
        } else {
          this.hint.textContent = 'Komplet je pripravljen za košarico.';
        }
      }

      this.submitButtons.forEach((button) => {
        button.disabled = this.loading || !complete || !this.products.length;
        button.textContent = this.loading ? 'Dodajam...' : button.dataset.originalText;
      });

      if (!this.loading) this.setStatus('');
    }

    renderSteps() {
      this.querySelectorAll('[data-kit-step-target]').forEach((button) => {
        button.classList.toggle('is-complete', Boolean(this.selection[button.dataset.kitStepTarget]));
      });
    }

    async addToCart() {
      if (!this.isComplete() || this.loading) return;
      this.loading = true;
      this.renderSummary();
      const bundleId = `alpe-kit-${Date.now()}`;
      const items = this.requiredLanes.map((lane) => {
        const selected = this.selection[lane];
        return {
          id: selected.variant.id,
          quantity: 1,
          properties: {
            '_alpe_bundle_id': bundleId,
            'Komplet': this.kitName,
            'Komponenta': this.laneLabel(lane)
          }
        };
      });

      try {
        const response = await fetch(`${this.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items })
        });
        const payload = await response.json();
        if (!response.ok) throw payload;
        const discountApplied = await this.applyDiscount();
        const cart = await this.fetchCart();
        this.updateCartCount(cart);
        document.dispatchEvent(new CustomEvent('alpe:kit:add', { detail: { cart, payload, bundleId, discountApplied } }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { cart, response: payload } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
        this.finish(discountApplied);
      } catch (error) {
        this.setStatus('Kompleta ni bilo mogoče dodati. Preveri izbrane velikosti in poskusi znova.');
      } finally {
        this.loading = false;
        this.renderSummary();
      }
    }

    async applyDiscount() {
      if (!this.discountCode) return false;
      try {
        const response = await fetch(`${this.root}discount/${encodeURIComponent(this.discountCode)}`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        return response.ok;
      } catch (error) {
        return false;
      }
    }

    async fetchCart() {
      try {
        const response = await fetch(`${this.root}cart.js`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        return await response.json();
      } catch (error) {
        return null;
      }
    }

    finish(discountApplied) {
      if (this.discountCode && !discountApplied) {
        window.location.href = `${this.root}discount/${encodeURIComponent(this.discountCode)}?redirect=${encodeURIComponent(`${this.root}cart`)}`;
        return;
      }
      if (this.afterAdd === 'drawer' && this.openCartDrawer()) return;
      window.location.href = `${this.root}cart`;
    }

    openCartDrawer() {
      const trigger = document.querySelector('.js-drawer-open-cart[aria-controls="CartDrawer"], .js-drawer-open-cart');
      if (trigger) {
        trigger.click();
        return true;
      }
      return false;
    }

    getSelected() {
      return this.requiredLanes.map((lane) => this.selection[lane]).filter(Boolean);
    }

    getMissingLanes() {
      return this.requiredLanes.filter((lane) => !this.selection[lane]);
    }

    isComplete() {
      return this.getMissingLanes().length === 0;
    }

    laneLabel(lane) {
      return { jersey: 'Dres', bib: 'Hlače', accessory: 'Dodatek' }[lane] || 'Kos';
    }

    variantLabel(entry) {
      return entry.variants.length === 1 && this.cleanVariantTitle(entry.variants[0].title) === 'Privzeta izbira'
        ? 'Izbira'
        : 'Velikost';
    }

    cleanVariantTitle(title) {
      return title === 'Default Title' ? 'Privzeta izbira' : title;
    }

    formatMoney(cents) {
      const amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'sl-SI', {
          style: 'currency',
          currency: this.currency
        }).format(amount);
      } catch (error) {
        return `${amount.toFixed(2)} ${this.currency}`;
      }
    }

    formatCount(count) {
      if (count === 1) return '1 kos';
      if (count === 2) return '2 kosa';
      return `${count} kosov`;
    }

    updateCartCount(cart) {
      if (!cart) return;
      document.querySelectorAll('.cart-link__bubble').forEach((bubble) => {
        bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
      });
      document.querySelectorAll('.cart-link__bubble-num, [data-cart-count]').forEach((node) => {
        node.textContent = cart.item_count;
      });
    }

    setStatus(text) {
      if (this.status) this.status.textContent = text;
    }

    setText(selector, text) {
      this.querySelectorAll(selector).forEach((node) => {
        node.textContent = text;
      });
    }

    escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      })[character]);
    }
  }

  if (!customElements.get('alpe-kit-builder')) {
    customElements.define('alpe-kit-builder', AlpeKitBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
